const inkeep_ai_bot = {
    intro_message: "Salut, je suis Logto AI!\n\nJe suis un assistant IA formé sur la documentation, les articles d'aide, et d'autres contenus.\n\nPose-moi toutes tes questions sur `Logto`.",
    chat_placeholder: 'Posez votre question à Logto AI pour obtenir un guide étape par étape',
    disclaimer_label: 'Avertissement Logto AI',
    disclaimer_tooltip: "Les réponses sont générées par l'IA et peuvent nécessiter une vérification.",
    example_questions_label: 'Exemples de questions',
    example_questions: [
        'Guide de démarrage rapide pour la configuration de Logto',
        "Configurer l'architecture multi-locataire",
        'Comment intégrer le profil utilisateur?',
    ],
    stop: 'Arrêter',
    clear: 'Recommencer',
    get_help: "Obtenir de l'aide",
    copy_chat: 'Copier',
    ask_ai_label: "Demander à l'IA",
    contact: 'Contact',
    discord: 'Discord',
};
export default Object.freeze(inkeep_ai_bot);
